module.exports = __webpack_public_path__ + "static/img/header_logo.00b60218.svg";